import { render } from "./IncubatorViewForm.vue?vue&type=template&id=16b85cae"
import script from "./IncubatorViewForm.vue?vue&type=script&lang=js"
export * from "./IncubatorViewForm.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ckyang/dev/olabbio/sites/olab-github/gf-olab-demo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__